import _extends from "@babel/runtime/helpers/extends";
import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React from 'react';
// components
import { Guide } from './Guide';

var Intro = _styled("div", {
  target: "e1cjij7q0",
  label: "Intro"
})(process.env.NODE_ENV === "production" ? {
  name: "1sq1gba",
  styles: "line-height:1.5;"
} : {
  name: "1sq1gba",
  styles: "line-height:1.5;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9HdWlkZXMvaW5kZXguanN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU93QiIsImZpbGUiOiIuLi8uLi9zcmMvR3VpZGVzL2luZGV4LmpzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCdcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuaW1wb3J0IHsgYXJyYXksIHN0cmluZyB9IGZyb20gJ3Byb3AtdHlwZXMnXG5cbi8vIGNvbXBvbmVudHNcbmltcG9ydCB7IEd1aWRlIH0gZnJvbSAnLi9HdWlkZSdcblxuY29uc3QgSW50cm8gPSBzdHlsZWQuZGl2YFxuXHRsaW5lLWhlaWdodDogMS41O1xuYFxuXG5HdWlkZXMucHJvcFR5cGVzID0ge1xuXHRndWlkZXM6IGFycmF5LFxuXHRpbnRybzogc3RyaW5nLFxufVxuXG4vKipcbiAqIFNob3J0IHNlY3Rpb24gb2YgdGhlIFNFTyBwYWdlIHRoYXQgZGlzcGxheXMgYSBzZXJpZXMgb2YgXCJkb3dubG9hZGFibGUgZ3VpZGVcIiBjYXJkcywgcmVuZGVyZWQgaW4gPEd1aWRlIC8+XG4gKi9cbmV4cG9ydCBmdW5jdGlvbiBHdWlkZXMoeyBndWlkZXMsIGludHJvIH0pIHtcblx0cmV0dXJuIChcblx0XHQ8PlxuXHRcdFx0e2ludHJvICYmIDxJbnRybyBkYW5nZXJvdXNseVNldElubmVySFRNTD17eyBfX2h0bWw6IGludHJvIH19IC8+fVxuXHRcdFx0e2d1aWRlcyAmJiBndWlkZXMubWFwKChndWlkZSkgPT4gPEd1aWRlIHsuLi5ndWlkZX0ga2V5PXtndWlkZS5pZH0gLz4pfVxuXHRcdDwvPlxuXHQpXG59XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

/**
 * Short section of the SEO page that displays a series of "downloadable guide" cards, rendered in <Guide />
 */
export function Guides(_ref) {
  var guides = _ref.guides,
      intro = _ref.intro;
  return /*#__PURE__*/React.createElement(React.Fragment, null, intro && /*#__PURE__*/React.createElement(Intro, {
    dangerouslySetInnerHTML: {
      __html: intro
    }
  }), guides && guides.map(function (guide) {
    return /*#__PURE__*/React.createElement(Guide, _extends({}, guide, {
      key: guide.id
    }));
  }));
}